<template>
  <section
    class="a-card"
    :class="{ 'a-card--alt': alt, 'a-card--clickable': clickable }"
    :style="cardStyle"
  >
    <header v-if="$slots.head || title" class="a-card__head">
      <div class="a-card__head-main">
        <h3 v-if="title" class="a-card__title">{{ title }}</h3>
        <p v-if="sub" class="a-card__sub">{{ sub }}</p>
        <slot name="head" />
      </div>
      <div v-if="$slots.actions" class="a-card__actions">
        <slot name="actions" />
      </div>
    </header>
    <div class="a-card__body" :style="bodyStyle">
      <slot />
    </div>
    <footer v-if="$slots.foot" class="a-card__foot">
      <slot name="foot" />
    </footer>
  </section>
</template>

<script>
export default {
  name: 'ACard',
  props: {
    title: { type: String, default: '' },
    sub:   { type: String, default: '' },
    padding: { type: [String, Number], default: 20 },
    overflow: { type: String, default: '' },
    alt: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false },
  },
  computed: {
    cardStyle() {
      return this.overflow ? { overflow: this.overflow } : {};
    },
    bodyStyle() {
      const p = typeof this.padding === 'number' ? `${this.padding}px` : this.padding;
      return { padding: p };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/pineapple';

.a-card {
  background: $p-panel;
  border: 1px solid $p-line;
  border-radius: $p-radius-lg;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &--alt {
    background: $p-panel-alt;
  }

  &--clickable {
    cursor: pointer;
    transition: transform 0.12s ease, box-shadow 0.12s ease;
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 18px rgba(31, 27, 20, 0.08);
    }
  }
}

.a-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid $p-line-soft;
}

.a-card__head-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.a-card__title {
  font-size: 15px;
  font-weight: 800;
  color: $p-ink;
  margin: 0;
}

.a-card__sub {
  font-size: 12px;
  color: $p-ink-mid;
  margin: 0;
}

.a-card__actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.a-card__body {
  flex: 1;
}

.a-card__foot {
  padding: 12px 20px;
  border-top: 1px solid $p-line-soft;
  background: $p-panel-alt;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
</style>
